import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-annule-cmd-fourn',
  templateUrl: './annule-cmd-fourn.component.html',
  styleUrls: ['./annule-cmd-fourn.component.scss']
})
export class AnnuleCmdFournComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        console.log('AnnuléCmdComponent initialized');
        this.dataService.filterOrdersByStatus('Annulé');
    }

}
